import fetchFromApiServer from 'services/api';

export function fetchInvestments(requestObject) {
  const url = `/fundinvestment-page/fund-investment`;
  return fetchFromApiServer('GET', url, requestObject);
}
